import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import Spacer from "@ui/spacer/Spacer";
import { Typo, TypoCaption } from "@ui/text/Typo";
import { useState } from "react";
import { GD } from "src/GD";
import { useMobile } from "src/hooks/useMobile";
import { FormParser } from "../FormParser";
import { StartScreenView } from "../StartScreenView";

const form = {
	password: "",
	$__password_type: "password",
	confirm_password: "",
	$__confirm_password_type: "password",
};

type TNewPassForm = typeof form;

export const RestorePassword = ({ code }: { code: string }) => {
	useLocale();
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState<IError>();
	const [completed, setCompleted] = useState<boolean>();
	const { isMobile, isTablet } = useMobile();

	const getForm = () => {
		return { ...form };
	};

	const validate = (data: TNewPassForm): boolean => {
		if (!data.password || !data.password) {
			setError({
				code: 0,
				message: msg("emptyPassword"),
			});
			return false;
		}
		if (data.password !== data.confirm_password) {
			setError({
				code: 0,
				message: msg("yourPasswordsDonTMatchPleaseCheckAndTryAgain"),
			});
			return false;
		}

		if (data.password.length < 8) {
			setError({
				code: 0,
				message: msg("passwordMustBeAtLeast8CharactersLong"),
			});
			return false;
		}

		const hasUpperCase = /[A-Z]/.test(data.password); // хотя бы одна заглавная буква
		const hasDigit = /\d/.test(data.password); // хотя бы одна цифра
		if (!hasUpperCase || !hasDigit) {
			setError({
				code: 0,
				message: msg("passwordMustIncludeAtLeastOneUppercaseLetterAndOneDigit"),
			});
			return false;
		}

		return true;
	};

	return (
		<StartScreenView busy={busy}>
			<Box
				sx={{
					width: isMobile ? "100%" : undefined,
					overflow: isMobile ? "auto" : undefined,
					display: "flex",
					height: "100%",
					minHeight: isMobile ? undefined : "700px",
					borderStartStartRadius: isMobile ? "0" : "12px",
					borderEndStartRadius: isMobile ? "0" : "12px",
					borderEndEndRadius: isTablet ? "12px" : "0",
					borderStartEndRadius: isTablet ? "12px" : "0",
					backgroundColor: "rgba(255,255,255,1)",
				}}>
				<Box
					sx={{
						padding: isMobile ? "34px 26px" : "60px",
						minWidth: isMobile ? "0" : "500px",
						width: isMobile ? "100%" : "auto",
						display: "flex",
						margin: isMobile ? "auto" : undefined,
						maxWidth: isMobile ? "500px" : undefined,
						flexDirection: "column",
					}}>
					{completed && (
						<Typo capitalize sx={{ fontSize: "26px", fontWeight: 400 }}>{msg("thePasswordHasBeen")}<br />{msg("successfullyChanged")}</Typo>
					)}
					{!completed && (
						<Typo capitalize sx={{ fontSize: "26px", fontWeight: 400 }}>
							<Typo capitalize sx={{ fontSize: "26px", fontWeight: 400 }}>{msg("toRestoreAccess")}<br />{msg("enterYourNewPassword")}</Typo>
						</Typo>
					)}
					<Spacer size="40px" />

					{error && (
						<>
							<Spacer size="12px" />
							<Error error={error} />
							<Spacer size="12px" />
						</>
					)}

					{!completed && (
						<FormParser
							key={"restoreForm"}
							ignoreObserver={true}
							secondaryButton={null}
							fullSizeButtons={true}
							primaryButton={{ title: msg("restorePassword"), variant: "primary", sx: { flexGrow: "1" } }}
							onSubmit={async (data: TNewPassForm): Promise<any> => {
								setError(undefined);
								if (validate(data)) {
									setBusy(true);
									const response = await GD.REQ_API.request({
										method: "auth/restore",
										data: {
											token: code,
											password: data.password,
										},
									});

									setBusy(false);

									if (response.error) return { data: data, error: response.error };
									if (response.data && response.data === true) {
										setCompleted(true);
									}
								}
								return { data };
							}}
							onRequest={async (): Promise<any> => {
								return getForm();
							}}
						/>
					)}
					{!completed && (
						<Box
							sx={{
								display: "flex",
								gap: "5px",
								alignItems: "center",
								margin: "25px 0",
							}}>
							<Box
								sx={{
									border: "1px solid rgba(0,0,0,0.14)",
									width: "100%",
								}}
							/>
							<TypoCaption italic>{msg("or")}</TypoCaption>
							<Box
								sx={{
									border: "1px solid rgba(0,0,0,0.14)",
									width: "100%",
								}}
							/>
						</Box>
					)}
					<Button
						sx={{
							width: "auto",
						}}
						variant="secondary"
						onClick={() => (location.href = "/")}>{msg("signIn")}</Button>
				</Box>
			</Box>
		</StartScreenView>
	);
};
